module.exports = __webpack_public_path__ + "static/media/icon-our-approach-2.8c2a02aa.svg";